import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { getArticleImageUrl } from '@/mocks/articleImages';

interface ArticleCardProps {
  article: Article;
  categoryName: string;
}

export default function ArticleCard({ article, categoryName }: ArticleCardProps) {
  const imageUrl = getArticleImageUrl(article.imageSeq);

  return (
    <article className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden group hover:border-primary-200 transition-all duration-300 flex flex-col">
      <Link to={`/article/${article.slug}`} className="block cursor-pointer">
        <div className="relative w-full aspect-[16/10] overflow-hidden">
          <img
            src={imageUrl}
            alt={article.title}
            title={`${article.title} - 膀胱健康管理`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-3 flex-wrap">
          <Link
            to={`/category/${article.category}`}
            className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
            {article.readTime} 分钟阅读
          </span>
        </div>
        <Link to={`/article/${article.slug}`} className="block flex-1">
          <h3 className="font-heading text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2 cursor-pointer">
            {article.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="mt-4 pt-3 border-t border-background-200/60 flex items-center justify-between">
          <span className="text-xs text-foreground-500">{article.author}</span>
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
        </div>
      </div>
    </article>
  );
}